<template>
  <div class="content">
    <div class="title-box">
      <span class="back-title">BUSINESS</span>
      <span class="fron-title">主要业务</span>
    </div>
    <div class="img">
      <div class="img-box" v-for="(item) in imgList" :key="item.key">
        <!--        <img :src="imgs && imgs[index] && imgs[index]['fileHttpUrl']">-->
        <!-- 'http://10.10.152.115'+ -->
        <img :src="item.listData['fileHttpUrl']">
        <div class="p">
          <p>{{item.name}}</p>
          <p class="p2" @click="() => {
            ['办事指南', '申办信息'].includes(item.desc1.name) ?
            open(item.desc1.url) :
            pushRouter(item.desc1.url)
          }
          "><span>{{ item.desc1.name }}</span></p>
          <p class="p2" @click="() => {
            pushRouter(item.desc2.url)
          }"><span>{{ item.desc2.name }}</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getIndex,
  getSwipeDetail
} from '@/api/homeIndex.js'
import {
  getModuleInfo,
  getModuleType
} from '@/api/moduleContent.js'
import {
  getFileDetails,
} from '@/api/file.js'
export default {
  name: 'sider-content-03',
  data () {
    return {
      imgList: [
        {
          name: '出国签证',
          desc1: { name: '日本签证', url: '/home/goaboard?achorPoint=f' },
          desc2: { name: '多国签证', url: '/home/goaboard?achorPoint=t' },
          url: require('../../../assets/images/icon_service_abroad_visa.png'),
          key: '1',
          code: '',
          codeList: [],
          listData: {}

        },
        {
          name: '领事认证',
          desc1: { name: '邮寄办理', url: '/home/consular-certification?achorPoint=f&m=RESA6104F9792115A9&h=650px' },
          desc2: { name: '窗口办理', url: '/home/consular-certification?achorPoint=f&m=RES91AD0D04F10EB80&h=650px' },
          url: require('../../../assets/images/icon_service_consul_auth.png'),
          key: '2',
          code: '',
          codeList: [],
          listData: {}
        },
        {
          name: '口译笔译',
          desc1: { name: '口译服务', url: '/home/translation-service?m=RES0B10779548CFC5D&achorPoint=f&h=778px' },
          desc2: { name: '文书笔译', url: '/home/translation-service?achorPoint=f&m=RES2054175786A0C72&h=778px' },
          url: require('../../../assets/images/icon_service_translate_server.png'),
          key: '3',
          code: '',
          codeList: [],
          listData: {}
        },
        {
          name: '国际会议',
          desc1: { name: '同传设备', url: '/home/translation-service?achorPoint=f&m=RES7E3508C5DEE6269&h=650px' },
          desc2: { name: '云视频会议', url: '/home/translation-service?achorPoint=f&m=RES46EEB34CF72ABB6&h=650px' },
          url: require('../../../assets/images/icon_service_interna_meet.png'),
          key: '5',
          code: '',
          codeList: [],
          listData: {}
        },
        {
          name: '接待培训',
          desc1: { name: '接待服务', url: '/home/translation-service?achorPoint=f&m=RESB8F2FF5ECD275A0&h=778px' },
          desc2: { name: ' 涉外培训', url: '/home/translation-service?achorPoint=f&m=RES88A5A7754A75DD2&h=778px' },
          url: require('../../../assets/images/icon_service_interna_train.png'),
          key: '4',
          code: '',
          codeList: [],
          listData: {}
        },
        {
          name: '境外服务',
          desc1: { name: '境外接待', url: '/home/service-abroad?achorPoint=f&m=RES42E240B4A0EF422&h=778px' },
          desc2: { name: '境外保险', url: '/home/service-abroad?achorPoint=f&m=RES9202721FCFD7A10&h=778px' },
          url: require('../../../assets/images/icon_service_abroad_serve.png'),
          key: '6',
          code: '',
          codeList: [],
          listData: {}
        },
        {
          name: '航空票务',
          desc1: { name: '航空订票', url: '/home/service-abroad?achorPoint=f&m=RES0E7F2F50AC98DC1&h=778px' },
          desc2: { name: '航空保险', url: '/home/service-abroad?achorPoint=f&m=RES2165D92346A4A67&h=778px' },
          url: require('../../../assets/images/icon_service_aviation_tick.png'),
          key: '7',
          code: '',
          codeList: [],
          listData: {}
        },
        {
          name: '外企服务',
          desc1: { name: '人事管理', url: '/home/foreign-company-service?achorPoint=f&m=RES56C68B16EEC4E70&h=778px' },
          desc2: { name: '外包服务', url: '/home/foreign-company-service?achorPoint=f&m=RES249B5667DAC13A5&h=778px' },
          url: require('../../../assets/images/icon_service_foreign_serve.png'),
          key: '8',
          code: '',
          codeList: [],
          listData: {}
        },
        {
          name: '外国人入境',
          desc1: { name: '办事指南', url: 'http://wb.fujian.gov.cn/ywxx/wgrrj/' },
          desc2: { name: '', url: '' },
          url: require('../../../assets/images/icon_service_foreigner_entry.png'),
          key: '9',
          code: '',
          codeList: [],
          listData: {}
        },
        {
          name: 'APEC商务旅行卡',
          desc1: { name: '申办信息', url: 'https://zwfw.fujian.gov.cn/person-todo/todo-fingerpost?unid=3030B12463CC1D45D71FE805176BA846&infoType=1' },
          desc2: { name: '', url: '' },
          url: require('../../../assets/images/icon_service_apec_travel_card.png'),
          key: '10',
          code: '',
          codeList: [],
          listData: {}
        }
      ],
      imgs: []
    }
  },
  created () {
    this.getModuleInfo()
    this.getImgs()
  },
  methods: {
    getModuleInfo(){
      getModuleInfo("RESC931F020F61406A").then(res=>{
        // console.log(res,'res========>')
        
        res.data.records&&res.data.records.forEach((e,index)=>{
          this.imgList[9-index].name = e.moduleName
          getModuleType(e.moduleCode).then(item=>{
            // console.log(item,'item========>')
            if(item.data.records){
              if(this.imgList[9-index].desc1.name){
                this.imgList[9-index].desc1.name = item.data.records[0].typeName
              }
              if(this.imgList[9-index].desc2.name){
                this.imgList[9-index].desc2.name = item.data.records[1].typeName
              }
            }
          })
        })
      })
    },
    async getImgs () {
      const res = await getIndex()
      const records = this._.get(res, 'data.records', [])
      this.img = []
      let code = [], appCode, tenantCode, picName
      records.forEach(items => {
        this.imgList.forEach(item => {
          if (items.typeName === item.name) {
            item.code = items.picCode
          }
        })
      })
      for (let i of records) {
        const pic = await getSwipeDetail(i.picCode, i.tenantCode)
        code.push(this._.get(pic, 'data.contentPicFileDtoList.0.fileCode', ''))
        appCode = this._.get(pic, 'data.appCode', '')
        tenantCode = this._.get(pic, 'data.tenantCode', '')
      }
      for (let item in this.imgList) {
        let codeList = []
        let pic = await getSwipeDetail(this.imgList[item].code, tenantCode)
        // appCode = this._.get(pic, 'data.appCode', '')
        // tenantCode = this._.get(pic, 'data.tenantCode', '')
        codeList.push(this._.get(pic, 'data.contentPicFileDtoList.0.fileCode', ''))
        this.imgList[item].codeList = codeList
        // console.log('1', appCode, '2', tenantCode, '3', codeList);
        let list = await getFileDetails(appCode, tenantCode, codeList)
        let iList = []
        iList.push(...Object.values(this._.get(list, 'data', {})))
        iList.forEach(items => {
          if (items.fileCode === this.imgList[item].codeList[0]) {
            this.imgList[item].listData = items
            // console.log(this.imgList);
          }
        })
      }
      // console.log(this.imgList);
      // const list = await getFileDetails(appCode, tenantCode, code)
      // this.imgs.push(...Object.values(this._.get(list, 'data', {})))
    },
    open (url) {
      window.open(url)
    }
  }
}
</script>

<style scoped lang='less'>
.content {
  height: 696px;
  background: white;
}
.title-box {
  padding-top: 28px;
  position: relative;
}
.back-title {
  width: 392px;
  height: 63px;
  font-size: 80px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #faf5f5;
  line-height: 80px;
  /* opacity: 0.16; */
}
.fron-title {
  width: 112px;
  height: 28px;
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 30px;
  position: absolute;
  margin: auto;
  left: 50%;
  transform: translateX(-50%);
  top: 52px;
}
.img {
  width: 1200px;
  // position: absolute;
  position: relative;
  margin: auto;
  // left: 50%;
  // transform: translateX(-50%);
  margin-top: 29px;
  font-size: 0px;
}
.img-box {
  width: 212px;
  height: 260px;
  display: inline-block;
  font-size: 20px;
  position: relative;
  overflow: hidden;
  img {
    width: 212px;
    height: 260px;
  }
  img:hover + .p {
    transition: bottom 0.7s;
    bottom: 0px;
    p {
      margin-top: 60px;
    }
    .p2 {
      margin: 0;
      padding: 0;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // text-decoration: underline;
      color: white;
      line-height: 36px;
    }
  }
  .p {
    margin: 0;
    padding: 0;
    width: 212px;
    height: 260px;
    line-height: 50px;
    //background: #000000;
    //opacity: 0.45;
    background-color: rgba(0, 0, 0, 0.45);
    position: absolute;
    z-index: 999;
    bottom: -208px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    // transition: bottom 1s;
    p {
      cursor: default;
      margin-top: 0px;
    }
    .p2 {
      margin: 0;
      padding: 0;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // text-decoration: underline;
      color: #ffffff;
      line-height: 36px;
      span {
        cursor: pointer;
      }
      span:hover {
        color: #cab484;
      }
    }
  }
  .p:hover {
    // transition: bottom 0s;
    bottom: 0px;
    p {
      margin-top: 60px;
    }
    .p2 {
      margin: 0;
      padding: 0;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      // text-decoration: underline;
      color: white;
      line-height: 36px;
    }
    .p2:hover {
      text-decoration: underline;
    }
  }
}
.img-box:not(:nth-of-type(1)),
.img-box:not(:nth-of-type(2)),
.img-box:not(:nth-of-type(3)),
.img-box:not(:nth-of-type(4)),
.img-box:not(:nth-of-type(5)) {
  margin-bottom: 20px;
}
.img-box:not(:nth-of-type(5)),
.img-box:not(:nth-of-type(10)) {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/home/homeIndex/siderContent03.vue